import React from "react";
import { Form, Switch } from "antd";
import type { FormInstance } from "antd";
import { Localize } from "components/service";

interface IEmailChannelStatusSwitchProps {
  form: FormInstance;
}

const EmailChannelStatusSwitch: React.FC<IEmailChannelStatusSwitchProps> = ({
  form,
}) => {
  const active = Form.useWatch("is_active", form) === true;

  return (
    <div className="email-channel-form-state">
      <span className="email-channel-form-label">
        <Localize>EMAIL_CHANNEL.Column_Status</Localize>
      </span>
      <div className="email-channel-form-control">
        <Form.Item name="is_active" valuePropName="checked" noStyle>
          <Switch />
        </Form.Item>
        <span className={active ? "is-active" : "is-inactive"}>
          <Localize>
            {active
              ? "EMAIL_CHANNEL.Status_Active"
              : "EMAIL_CHANNEL.Status_Inactive"}
          </Localize>
        </span>
      </div>
      <small>
        <Localize>
          {active
            ? "EMAIL_CHANNEL.Status_Active_Description"
            : "EMAIL_CHANNEL.Status_Inactive_Description"}
        </Localize>
      </small>
    </div>
  );
};

export default EmailChannelStatusSwitch;
